import { HandType } from '@ps/web-poker-types';

import {
  BASE_POKER_STR,
  NGCDN_BASE_URL,
  NG_CDN_IMAGE_SUFFIX,
  NG_CDN_WIDE_IMAGE_SUFFIX,
  TILE_IMAGE_FORMAT,
  getRailCdnBaseUrl
} from './game';
import { getTournGroupStr, isNGSAGFlash } from './helpers';
import { TournGroupTypes } from './tournGroups';
import { eSpinAndGoPublicationFlags } from './types';

export default function imageSagFormatter(
  game: number,
  flags: number,
  ngSagFlags: number,
  tournGroup: number,
  isThemeV2Image?: boolean
) {
  let baseSagStr = 'spinandgo';
  const railCdnBaseUrl = getRailCdnBaseUrl(!!isThemeV2Image);
  if (tournGroup > 0) {
    const baseSngPromoStr = `${NGCDN_BASE_URL}${BASE_POKER_STR}${getTournGroupStr(
      tournGroup,
      isThemeV2Image
    )}`;
    if (
      isNGSAGFlash(ngSagFlags) &&
      (tournGroup === TournGroupTypes.TournGroup_Promo3 ||
        tournGroup === TournGroupTypes.TournGroup_sagpromo3)
    ) {
      const suffix = isThemeV2Image ? NG_CDN_IMAGE_SUFFIX : NG_CDN_WIDE_IMAGE_SUFFIX;
      return `${baseSngPromoStr}${TILE_IMAGE_FORMAT}`.replace(suffix, `_flash${suffix}`);
    }
    return `${baseSngPromoStr}${TILE_IMAGE_FORMAT}`;
  }

  // eslint-disable-next-line no-bitwise
  if (flags & eSpinAndGoPublicationFlags.espfSagMax) {
    return `${railCdnBaseUrl}${BASE_POKER_STR}${baseSagStr}_max${TILE_IMAGE_FORMAT}`;
  }

  if (isNGSAGFlash(ngSagFlags)) {
    return `${railCdnBaseUrl}${BASE_POKER_STR}${baseSagStr}_flash${TILE_IMAGE_FORMAT}`;
  }

  if (HandType[game] === HandType[HandType.OMAHA]) {
    baseSagStr += '_omaha';
  }

  return `${railCdnBaseUrl}${BASE_POKER_STR}${baseSagStr}${TILE_IMAGE_FORMAT}`;
}
